const conditionalFormatting = (cellValue = '', conditions) => {
    for (const {criteria, value, formats} of conditions) {
        if(typeof cellValue === 'object') return;
        if (criteria === 'contains') {
            const isContains = contains(cellValue, value, formats);
            if (isContains) {
                return isContains;
            }
        }
        if (criteria === 'notContains') {
            const isNotContains = notContains(cellValue, value, formats);
            if (isNotContains) {
                return isNotContains;
            }
        }
        if (criteria === 'equal') {
            const isEqual = equal(cellValue, value, formats);
            if (isEqual) {
                return isEqual;
            }
        }
        if (criteria === 'notEqual') {
            const isNotEqual = notEqual(cellValue, value, formats);
            if (isNotEqual) {
                return isNotEqual;
            }
        }
        if (criteria === 'startWith') {
            const isStartWith = startWith(cellValue, value, formats);
            if (isStartWith) {
                return isStartWith;
            }
        }
        if (criteria === 'endsWith') {
            const isEndsWith = endsWith(cellValue, value, formats);
            if (isEndsWith) {
                return isEndsWith;
            }
        }
        if (criteria === 'lessThan') {
            const isLessThan = lessThan(cellValue, value, formats);
            if (isLessThan) {
                return isLessThan;
            }
        }
        if (criteria === 'greaterThan') {
            const isGreaterThan = greaterThan(cellValue, value, formats);
            if (isGreaterThan) {
                return isGreaterThan;
            }
        }
        if (criteria === 'greaterOrEqual') {
            const isGreaterOrEqual = greaterOrEqual(cellValue, value, formats);
            if (isGreaterOrEqual) {
                return isGreaterOrEqual;
            }
        }
        if (criteria === 'lessOrEqual') {
            const isLessOrEqual = lessOrEqual(cellValue, value, formats);
            if (isLessOrEqual) {
                return isLessOrEqual;
            }
        }
    }
};

export default conditionalFormatting;

function conditionalStyles(formats = {}) {
    return {
        fontStyle: formats.italic ? 'italic' : undefined,
        fontWeight: formats.bold ? 'bold' : undefined,
        textDecoration: formats.underlined ? 'underline' : undefined,
        color: formats.color,
        background: formats.background
    }
}


function contains(value, conditionValue, formats) {
    if (value.includes(conditionValue)) {
        return conditionalStyles(formats);
    } else {
        return false;
    }
}

function notContains(value, conditionValue, formats) {
    let isNotContains = value.indexOf(conditionValue) === -1;
    if (isNotContains) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}

function equal(value, conditionValue, formats) {
    let isEqual = value === conditionValue;
    if (isEqual) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}

function notEqual(value, conditionValue, formats) {
    let isNotEqual = value !== conditionValue;
    if (isNotEqual) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}

function startWith(value, conditionValue, formats) {
    let isStartWith = value.startsWith(conditionValue);
    if (isStartWith) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}

function endsWith(value, conditionValue, formats) {
    let isEndsWith = value.endsWith(conditionValue);
    if (isEndsWith) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}

function lessThan(value, conditionValue, formats) {
    let isLessThan = value < conditionValue;
    if (isLessThan) {
        return conditionalStyles(formats)
    } else {
        return false
    }
}

function greaterThan(value, conditionValue, formats) {
    let isGreaterThan = value > conditionValue;
    if (isGreaterThan) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}

function lessOrEqual(value, conditionValue, formats) {
    let isLessOrEqual = value <= conditionValue;
    if (isLessOrEqual) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}

function greaterOrEqual(value, conditionValue, formats) {
    let isGreaterOrEqual = value >= conditionValue;
    if (isGreaterOrEqual) {
        return conditionalStyles(formats)
    } else {
        return false;
    }
}


// function notRange(value, conditionValue, formats) {
//
// }
//
// function range(value, conditionValue, formats) {
//
// }
